// Uploaded assets (product/category/brand images, etc.) are always served
// from this domain, regardless of which API environment the app targets.
export const URLS_UPLOADS = 'https://api.quickcom.ma';

export default URLS_UPLOADS;
